// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"feedd533","239":"043bea1f","371":"909ae58b","453":"b2cd085d","732":"66c1c7ec"}[chunkId] + ".chunk.js";
};